import { isEmpty } from 'lodash'
import { validate as isValidEmail } from 'email-validator'
import type {
  DataType,
  FormField,
} from '@labrav/react-components/lib/@types/types/forms'

import { UserRole } from '../../utils/roles'
import type { ErrorUsers } from '../../modules/addUserForm/reducer'

export const STAFF_INVITE_DISABLED_MESSAGE =
  'Your role does not permit you to invite members.'

export const getEmailValidationMessage = (value: string) => {
  if (isEmpty(value)) {
    return 'Please provide email address.'
  }

  return !isValidEmail(value) ? 'Please provide valid email address.' : ''
}

export const getUserRoleOptions = () =>
  Object.entries(UserRole).map(([key, value]) => ({
    label: value,
    value: key,
  }))

export const hasAddUserErrors = (errors: ErrorUsers[]) =>
  errors.filter(errorItem => !isEmpty(errorItem.error)).length > 0

export const buildAddNewMemberFields = (
  formDisabled: boolean,
  userRoleOptions: { label: string; value: string }[]
): FormField => ({
  title: 'Select a role',
  placeHolder: 'Select a role',
  id: 'role',
  isRequired: false,
  humanReadableKey: 'selectRole',
  isReadOnly: formDisabled || false,
  isCustom: false,
  defaultValue: 'PARTNER_STAFF',
  dataType: 'enum' as DataType,
  options: userRoleOptions,
})
